import React, { useEffect, type ReactElement } from 'react';
import { Box, Typography } from '@mui/material';
import Subscription from '../../components/SignUp/Subscription/Subscription';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { organizationActions } from '../../redux/organization/organizationSlice';

export default function UpdateSubscription(): ReactElement {
  const dispatch = useAppDispatch();
  const { subscriptionUpdateSucess } = useAppSelector((state) => state.organization);

  useEffect(() => {
    dispatch(organizationActions.getOrganizationSubscriptionAsync());
  }, [dispatch, subscriptionUpdateSucess]);

  return (
    <Box>
      <Subscription isUpdatable />
    </Box>
  );
}
